import { activePhoneRegex, createRules } from "@hilma/forms";
import { isMobilePhone, length } from "class-validator";

export const loginPhoneRules = createRules({
	phone: { activeRegex: activePhoneRegex, required: true, classValidator: (value: string) => /* isMobilePhone(value, 'he-IL') && */ (new RegExp(/^\d+/)).test(value) && Number(value) > 100000000 &&Number(value) < 599999999/* && length(value.toString(), 10, 10)  */ },
});